import { axiosInstance } from "@/axios/interceptors";
import { ZodSentryReporter } from "@/lib/zod-sentry-reporter";
import { z } from "zod";

export type CreateIdentityVerificationSessionPayload = {
	user_id: number;
	redirect_url: string;
	location_id: number;
};

const CreateVerificationSessionResponseSchema = z.object({
	token: z.string(),
});

export type CreateVerificationSessionResponse = z.infer<
	typeof CreateVerificationSessionResponseSchema
>;

// Schema for verification session data - adjust based on actual API response
const VerificationSessionSchema = z.object({
	status: z.union([
		z.literal("success"),
		z.literal("fail"),
		z.literal("awaiting_user_input"),
		z.literal("processing_data"),
		z.literal("expired"),
		z.literal("awaiting_manual_review"),
		z.literal("manual_success"),
		z.literal("manual_fail"),
		z.literal("canceled"),
	]),
});

export type VerificationSession = z.infer<typeof VerificationSessionSchema>;
export type GetVerificationSessionsResponse = z.infer<
	typeof VerificationSessionSchema
>;

export async function createIdentityVerificationSession(
	payload: CreateIdentityVerificationSessionPayload,
) {
	const response = await axiosInstance.post(
		`/locations/${payload.location_id}/mobile/verification_sessions`,
		payload,
	);
	return ZodSentryReporter.parse(
		CreateVerificationSessionResponseSchema,
		response,
	);
}

export type GetVerificationSessionsParams = {
	guest_id: number;
	user_id: number;
	location_id: number;
};

export async function getVerificationSessions(
	params: GetVerificationSessionsParams,
) {
	const url = `/locations/${params.location_id}/mobile/verification_sessions`;

	const response = await axiosInstance.get(url, {
		params,
	});
	return ZodSentryReporter.parse(VerificationSessionSchema, response);
}
